import React, { useEffect, useContext, useState } from 'react';

import { debounce } from 'lodash';
import { Card } from 'components/UI';
import { UserContext } from 'context';
import { Grid, Box } from '@material-ui/core';
import { CardStyles } from './StatisticsCard.styled';
import { useDispatch, useSelector } from 'react-redux';
import FleetStatisticsCard from './FleetStatisticsCard';
import FleetStatisticsTable from './FleetStatisticsTable';
import { SubscriptionsActions } from 'state/modules/subscriptions';
import { truncateKeywordSpaces } from 'utils/utils';

const Statistics = () => {
  const dispatch = useDispatch();
  const CardClasses = CardStyles();
  const { orgType } = useContext(UserContext);
  const config = useSelector((state) => state.config?.settings);
  const dashboardSettings = config.integrations?.dashboard_settings?.noc;
  const {
    fleetAggregates: { list, pagination },
    fetchingFleetAggregates,
  } = useSelector((state) => state.subscriptions);

  const [params, setParams] = useState({
    page: 1,
    limit: 10,
    sort_by_name: true,
    upcoming: dashboardSettings?.upcoming || 6,
    type: orgType === 'msOwnerOrg' ? 'location' : 'service',
  });

  const getFleetAggregates = () => {
    dispatch(SubscriptionsActions.fetchAggregates(params));
  };

  const handlePageChange = (page) => {
    const newParams = { page: page, limit: params.limit };
    setParams({ ...params, ...newParams });
  };

  /**
   * Handle per rows (limit) change on table
   * @param {number} limit New limit value
   */
  const handlePerRowsChange = async (limit) => {
    const newParams = { page: 1, limit: limit };
    setParams({ ...params, ...newParams });
  };

  const handleChangeFilter = debounce((filters) => {
    setParams({ ...filters });
  }, 500);

  // search by status, keyword and organization
  const search = (name, value) => {
    const filters = {
      ...params,
      page: 1,
      // validate if value is an object
      [name]: value,
    };
    // remove empty fields
    Object.keys(filters).forEach(
      (key) => !filters[key] && filters[key] !== false && key !== 'keyword' && delete filters[key]
    );
    if (filters?.keyword) {
      filters.keyword = truncateKeywordSpaces(filters.keyword);
    }
    handleChangeFilter({ ...filters });
  };

  useEffect(() => {
    getFleetAggregates();
  }, [params]); // eslint-disable-line

  return (
    <Card
      enableCollapse
      title="Statistics"
      headerActionType="vertical"
      onRefresh={() => getFleetAggregates()}
      contentRootClasses={CardClasses}
      loading={fetchingFleetAggregates}
    >
      <Grid container spacing={2} style={{ marginTop: 0, marginBottom: 0 }}>
        <Grid item xs={12}>
          <Box px={4} pt={2}>
            <FleetStatisticsCard parameters={{ keyword: params.keyword }} />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <FleetStatisticsTable
            list={list}
            search={search}
            params={params}
            pagination={pagination}
            loading={fetchingFleetAggregates}
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}
          />
        </Grid>
      </Grid>
    </Card>
  );
};

export default Statistics;
